import React from 'react'
import { createFileRoute } from '@tanstack/react-router'

import { foodRestrictionsQuery, sourcesQuery, tagsQuery } from '@/api'
import { NewRecipe } from '@/api/types'
import EditOrCreateRecipe from '@/features/recipes/EditOrCreateRecipe/EditOrCreateRecipe'
import { languagesQuery } from '@/api/languages'
import { adminsAndAmbassadorsQuery } from '@/api/users'

export const Route = createFileRoute('/recipes_/new')({
  loader: async ({ context: { queryClient } }) => {
    const [tags, allergens, languages, authors, sources] = await Promise.all([
      queryClient.ensureQueryData(tagsQuery),
      queryClient.ensureQueryData(foodRestrictionsQuery),
      queryClient.ensureQueryData(languagesQuery),
      queryClient.ensureQueryData(adminsAndAmbassadorsQuery),
      queryClient.ensureQueryData(sourcesQuery),
    ])

    return { tags, allergens, languages, authors, sources }
  },
  component: RecipeComponent,
})

const defaultRecipe: NewRecipe = {
  name: '',
  status: 'DRAFT',
  recipeIngredients: [],
  tags: [],
}

function RecipeComponent() {
  const { tags, allergens, languages, authors, sources } = Route.useLoaderData()

  return (
    <EditOrCreateRecipe
      originalRecipe={defaultRecipe}
      tags={tags}
      allergens={allergens}
      languages={languages}
      authors={authors}
      sources={sources}
    />
  )
}
